import {Component, input} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {NgClass} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-referral-cabinet-menu',
  imports: [RouterLink, RouterLinkActive, TranslateModule, NgClass],
  templateUrl: './referral-cabinet-menu.component.html',
  styles: `
    .cabinet-menu {
      grid-template-columns: repeat(6, minmax(0, 1fr));
    }

    .cabinet-menu__item__link {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 10px;
      min-width: 0;
      white-space: nowrap;
      font-size: clamp(0.78rem, 0.83vw, 1rem);
    }

    .cabinet-menu__item__link > span {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .cabinet-menu__item__link > img {
      width: 15%;
      flex: 0 0 auto;
      max-width: 18px;
    }

    @media screen and (max-width: 992px) {
      .cabinet-menu {
        grid-template-columns: none;
      }

      .cabinet-menu__item__link {
        font-size: 0.75rem;
      }
    }
  `
})
export class ReferralCabinetMenuComponent {
  show = input(false);

  menuList = [
    {id: 'partners-cabinet', titleKey: 'referralCabinetMenu.dashboard', urlPath: 'partners-cabinet'},
    {id: 'challenges', titleKey: 'referralCabinetMenu.challenges', urlPath: 'challenges'},
    {id: 'statistics', titleKey: 'referralCabinetMenu.statistics', urlPath: 'statistics'},
    {id: 'account', titleKey: 'referralCabinetMenu.account', urlPath: 'account'},
    {id: 'create-link', titleKey: 'referralCabinetMenu.createLink', urlPath: 'create-link'},
  ];
}
